const test = {

	utilityButton: "https://verification.diro.live/?buttonid=O.IN-v6EsGi-FFR1&trackid=",

	//BANK BUTTON LINK
	bankButton: "https://verification.diro.live/?buttonid=O.IN-v6EsGi-UO1G&trackid=",
	
	feedbackUrl: "https://api2.diro.live/cbre/api/sendsupportemail",
	frameSource: "https://session.diro.live/ https://verification.diro.live/",

	//bank button full doc
	bankButtonFullDoc: "https://verification.diro.live/?buttonid=O.IN-v6EsGi-Ha5C&trackid=",
	// bankButtonFullDoc: "https://diro.io/verification?buttonid=O.IN-ZGIvIV-nA08&trackid=",
	dirostatus: "https://api2.diro.live/org/api/getbtnStatus",

	staticUtilityButtonId: "O.IN-v6EsGi-FFR1",
	staticBankOnlyButtonId: "O.IN-v6EsGi-UO1G",
	staticBankFullButtonId: "O.IN-v6EsGi-UO1G",
	uploadCDN_CSS: "https://smartupload.diro.io/widgets-stage2/diro.css",
	uploadCDN_JS: "https://smartupload.diro.io/widgets-stage2/diro.js",
	uploadBankBtn: "O.IN-v6EsGi-c0uo-sandbox",
	uploadAddressBtn: "O.IN-v6EsGi-AaNT-sandbox",
	// staticUtilityButtonId: "O.IN-ZGIvIV-Kdhm",
	// staticBankOnlyButtonId: "O.IN-ZGIvIV-Sy6C",
	// staticBankFullButtonId: "O.IN-ZGIvIV-nA08",

	sentryDSN: "https://4e8f158588514409b25905afa75f18b2@o1042621.ingest.sentry.io/4506834708987904",
	environment: "test",
};

const prod = {

	utilityButton: "https://verification.diro.io/?buttonid=O.SG-5y1NbH-UKpq&trackid=",
	
	//BANK BUTTON LINK
	bankButton: "https://verification.diro.io/?buttonid=O.SG-5y1NbH-doHO&trackid=",

	//bank button full doc
	bankButtonFullDoc: "https://verification.diro.io/?buttonid=O.SG-5y1NbH-doHO&trackid=",

	dirostatus: "https://prod.dirolabs.com/Zuul-1.0/organization-2.0/dirostatus",
	feedbackUrl: "https://api.diro.io/cbre/api/sendsupportemail",
	frameSource: "https://session.diro.io/ https://diro.io/",
	// feedbackUrl: "https://api2.diro.live/cbre/api/sendsupportemail",
	sentryDSN: "https://97271d0894a5dc96a2d90e660654f19a@o305199.ingest.us.sentry.io/4508319431000064",
	uploadCDN_CSS: "https://smartupload.diro.io/widgets/diro.css",
	uploadCDN_JS: "https://smartupload.diro.io/widgets/diro.js",
	staticUtilityButtonId: "O.SG-5y1NbH-UKpq",
	staticBankOnlyButtonId: "O.SG-5y1NbH-doHO",
	staticBankFullButtonId: "O.SG-5y1NbH-doHO",
	uploadBankBtn: "O.SG-5y1NbH-K1GP",
	uploadAddressBtn: "O.SG-5y1NbH-vszW",

	environment: "prod",
};
export { test   };
export { prod as env };
